import { render, staticRenderFns } from "./PsycomotorSkills.vue?vue&type=template&id=e0c81770"
import script from "./PsycomotorSkills.vue?vue&type=script&lang=js"
export * from "./PsycomotorSkills.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports